import { useState } from 'react';
import styled, { css } from 'styled-components';
import { Box, Heading } from 'tombac';
import { ContractStatus } from "../../contracts/contractTypes";
import LimitsSummary from "./LimitsSummary";
import "./ProductForm.css";
import { ProductLogo } from "./ProductLogo";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ProductForm(props) {
  const {
    contract,
    editableLimits,
    packages,
    productValues
  } = props;
  const [isLimitsEditOpen, setIsLimitsEditOpen] = useState(false);
  return /*#__PURE__*/_jsxs(Box, {
    $alignItems: "center",
    $display: "grid",
    $gap: "1sp 2sp",
    $gridTemplateColumns: "min-content 1fr",
    "data-sentry-element": "Box",
    "data-sentry-component": "ProductForm",
    "data-sentry-source-file": "ProductForm.tsx",
    children: [/*#__PURE__*/_jsx(ProductLogoContainer, {
      expired: contract.status === ContractStatus.Expired,
      "data-sentry-element": "ProductLogoContainer",
      "data-sentry-source-file": "ProductForm.tsx",
      "data-sentry-element": "ProductLogoContainer",
      children: /*#__PURE__*/_jsx(ProductLogo, {
        height: 40,
        productId: productValues.product.id,
        width: 40,
        "data-sentry-element": "ProductLogo",
        "data-sentry-source-file": "ProductForm.tsx",
        "data-sentry-element": "ProductLogo"
      })
    }), /*#__PURE__*/_jsx(ProductHeader, {
      ...props,
      "data-sentry-element": "ProductHeader",
      "data-sentry-source-file": "ProductForm.tsx",
      "data-sentry-element": "ProductHeader"
    }), /*#__PURE__*/_jsx(LimitsSummary, {
      ...props,
      contractId: contract.id,
      readOnly: !editableLimits,
      isEditOpen: isLimitsEditOpen,
      onRequestEditClose: () => setIsLimitsEditOpen(false),
      onRequestEditOpen: () => setIsLimitsEditOpen(true),
      productValues: productValues,
      packages: packages,
      "data-sentry-element": "LimitsSummary",
      "data-sentry-source-file": "ProductForm.tsx",
      "data-sentry-element": "LimitsSummary"
    })]
  });
}
function ProductHeader({
  productValues
}) {
  return /*#__PURE__*/_jsx(Heading, {
    as: "h3",
    className: "Product__name-heading",
    level: 5,
    "data-sentry-element": "Heading",
    "data-sentry-component": "ProductHeader",
    "data-sentry-source-file": "ProductForm.tsx",
    children: productValues.product.displayName
  });
}
const ProductLogoContainer = styled.div.withConfig({
  displayName: "ProductForm__ProductLogoContainer"
})(["& > svg{display:block;}", ""], ({
  expired
}) => expired && css(["filter:grayscale(100%);opacity:0.5;"]));